export default __webpack_public_path__ + "static/media/more.4ac85129.svg";